<template>
    <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="container-fluid">
            <div class="navbar-header">
                <router-link class="navbar-brand" :to="{ name: 'Home' }">
                  <span>
                    <img src="@/assets/images/logo.png" alt=""/>
                    <span style="color: #fff; margin-left: 5px;">臺北市私立靜心高級中學</span>
                  </span>
                </router-link>
            </div>
            <div id="navbar" class="navbar-collapse collapse">
                <div class="top-search">
                    <form class="navbar-form navbar-right" onsubmit="return false">
                        <input type="text" class="form-control" v-model="searchWord" placeholder="請輸入影片名稱搜尋...">
                        <input type="submit" @click="sendSearch" value="">
                    </form>
                </div>
                <div class="header-top-right">

                    <div class="signin" v-if="$store.state.token">
                        <span class="user_name">
                            <a @click="userInfo" href="javascript:void(0);">
                                <span class="glyphicon glyphicon-user" aria-hidden="true"></span>{{ userName }}
                            </a>
                        </span>
                        <a @click="logout" href="javascript:void(0);" class="play-icon">登出</a>
                    </div>

                    <div class="signin" v-else>
                        <a href="javascript:void(0);" @click="showLogin" class="play-icon popup-with-zoom-anim">登入</a>
                        <modal name="modal-login">
                          <div>
                            <h3>登入</h3>
                            <h6 class="error-msg">{{loginMessage}}</h6>
                            <div class="signup">
                                <form onsubmit="return false" style="text-align:center;">
                                    <input type="text" class="email" placeholder="帳號" required="required" v-model="loginAccount" autofocus/>
                                    <input type="password" placeholder="密碼" required="required" v-model="loginPassword" autocomplete/>
                                    <div class="clearfix"></div>
                                    <input @click="login" type="submit" value="登入"/>
                                </form>
                            </div>
                            <div class="clearfix"></div>
                          </div>
                        </modal>
                    </div>

                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <v-dialog :clickToClose="false" />
    </nav>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      searchWord: '',
      loginAccount: '',
      loginPassword: '',
      loginMessage: ''
    }
  },
  watch: {
    '$route' (to, from) {
    }
  },
  computed: {
    userName: function () {
      return this.$store.state.userInfo.user_name
    }
  },
  mounted () {
    $(document).ready(function () {
      $('.popup-with-zoom-anim').magnificPopup({
        type: 'inline',
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in'
      })
    })
  },
  methods: {
    sendSearch: function () {
      let self = this
      if (self.searchWord !== '') {
        self.$router.push({ name: 'VideoSearch', query: { q: self.searchWord } })
        $('.header__nav .search > input').addClass('empty')
        self.searchWord = ''
      }
    },
    login: function () {
      let loginInfo = {
        member_account: this.loginAccount,
        password: this.loginPassword
      }
      let self = this
      self.loginMessage = ''
      this.$store.dispatch('login', loginInfo)
        .then((response) => {
          self.loginAccount = ''
          self.loginPassword = ''
          self.loginMessage = ''
          window.location.reload()
        }).catch(err => {
          self.loginAccount = ''
          self.loginPassword = ''
          self.loginMessage = (err.data.msg) ? err.data.msg : `登入失敗，請重新登入`
          console.log((err.data.msg) ? err.data.msg : `登入失敗，請重新登入`)
        })
    },
    logout: function () {
      let self = this
      this.$modal.show('dialog', {
        title: '登出提示',
        text: '您確定要登出系統嗎？',
        buttons: [
          {
            title: '取消',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: '確定',
            handler: () => {
              this.$store.dispatch('logout', self.$store.state.token)
                .then(() => {
                  window.location.reload()
                })
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    logoutByError: function () {
      let self = this
      this.$modal.show('dialog', {
        title: '錯誤提示',
        text: '您目前未登入系統，或資料有誤，請重新登入',
        buttons: [
          {
            title: '確定',
            handler: () => {
              this.$store.dispatch('logout', self.$store.state.token)
                .then(() => {
                  window.location.reload()
                })
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    userInfo () {
      this.$modal.show('dialog', {
        title: '視窗提示',
        text: `您的帳號：` + this.$store.state.userInfo.user_account,
        buttons: [
          {
            title: '關閉',
            handler: () => {
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    showLogin () {
      this.$modal.show('modal-login')
    }
  }
}
</script>

<style scoped>
    .user_name .glyphicon {
        font-size: 1.1em;
        margin-right: .2em;
        color: #ffffff;
    }
    h3 {
        text-align: center;
    }
    .error-msg {
        font-size: 2em;
        color: #ee0000;
        text-align: center;
    }
</style>
